import {
  Semanticpmpmvt7fldq2 as Semantic,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  BarSemantic_getInstance5oimrhs7x11g as BarSemantic_getInstance,
  NavSemantic_getInstance3ooa6be5xy9hs as NavSemantic_getInstance,
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  ErrorSemantic_getInstanceqmizdq1y2zzq as ErrorSemantic_getInstance,
  FocusSemantic_getInstance2hulmpskh8zvf as FocusSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  PopoverSemantic_getInstance1gd43d9y00yoy as PopoverSemantic_getInstance,
  InvalidSemantic_getInstance19jq406epp0mv as InvalidSemantic_getInstance,
  WarningSemantic_getInstance2xxn62yaantj2 as WarningSemantic_getInstance,
  DangerSemantic_getInstance3i0xmw7we3iku as DangerSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  Themeex1jjdf3pz9y as Theme,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_AppDimensions1ckwvsuun6046 as get_AppDimensions,
  Companion_getInstance3ks9yb1iyfxr2 as Companion_getInstance,
} from '../components/nav/AppDimensions.mjs';
import {
  Constant5dc3leeorpdb as Constant,
  ForceConstant11m1vt5jr2l8f as ForceConstant,
  RatioOfSize1ip5bd7oxn8ba as RatioOfSize,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ForegroundSemantic2og103ajpnjfv as ForegroundSemantic } from './colorManagement.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Companion_getInstancenv8qpb0wanrh as Companion_getInstance_0,
  applyAlpha3k2fcxahu1lgz as applyAlpha,
  darken120sc580p6xj9 as darken,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  times2ukvaf6yk96p2 as times,
  divkhq3vjih9fcw as div,
  timesx4ey3un7ihw1 as times_0,
  FontAndStyle1comk0qshc8kn as FontAndStyle,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { copy52djz8jpwbje as copy } from './Titles.mjs';
import { ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance } from '../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { color1u2lxyvdop1o6 as color } from '../components/project/work/payApps/data.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../Resources.js.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { lens3m3nj3zkwtu6r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var invalidOutlineTheme;
function get_appThemeLive() {
  _init_properties_appTheme_kt__k2rfoo();
  return appThemeLive;
}
var appThemeLive;
var OutlinedClass;
function Outlined() {
  if (OutlinedClass === VOID) {
    class $ extends Semantic() {
      static ijo() {
        Outlined_instance = null;
        var $this = this.dd1('outlnd');
        Outlined_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.jd1(theme, VOID, VOID, VOID, new (Constant())(get_AppDimensions().rg2_1), VOID, VOID, VOID, VOID, VOID, get_AppDimensions().qg2_1);
      }
      toString() {
        return 'Outlined';
      }
      hashCode() {
        return 1873606292;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Outlined()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Outlined');
    OutlinedClass = $;
  }
  return OutlinedClass;
}
var Outlined_instance;
function Outlined_getInstance() {
  if (Outlined_instance === VOID)
    Outlined().ijo();
  return Outlined_instance;
}
function get_outlined(_this__u8e3s4) {
  _init_properties_appTheme_kt__k2rfoo();
  return _this__u8e3s4.jbb(Outlined_getInstance());
}
function get_redText(_this__u8e3s4) {
  _init_properties_appTheme_kt__k2rfoo();
  return _this__u8e3s4.jbb(ForegroundSemantic().cgi(AppColors_getInstance().jfz_1.zg9_1));
}
function AuthDialogSemantic$default$lambda($this$to, it) {
  return it.cb1_1;
}
var AuthDialogSemanticClass;
function AuthDialogSemantic() {
  if (AuthDialogSemanticClass === VOID) {
    class $ extends Semantic() {
      static kjo() {
        AuthDialogSemantic_instance = null;
        var $this = this.dd1('athdlg');
        AuthDialogSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_cornerRadii = new (Constant())(get_rem(1));
        var tmp1_background = Companion_getInstance_0().taz_1;
        var tmp2_elevation = get_dp(1);
        var tmp3_padding = Edges().cd0(get_AppDimensions().zg1_1);
        var tmp = CardSemantic_getInstance();
        var tmp4_derivations = mapOf(to(tmp, AuthDialogSemantic$default$lambda));
        return this.jd1(theme, false, VOID, tmp2_elevation, tmp0_cornerRadii, VOID, tmp3_padding, VOID, VOID, VOID, VOID, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'AuthDialogSemantic';
      }
      hashCode() {
        return -1815803224;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthDialogSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AuthDialogSemantic');
    AuthDialogSemanticClass = $;
  }
  return AuthDialogSemanticClass;
}
var AuthDialogSemantic_instance;
function AuthDialogSemantic_getInstance() {
  if (AuthDialogSemantic_instance === VOID)
    AuthDialogSemantic().kjo();
  return AuthDialogSemantic_instance;
}
function OverlayHover$default$lambda($this$to, it) {
  return $this$to.md1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_0().vaz_1.ecz(0.1)).bb1_1;
}
var OverlayHoverClass;
function OverlayHover() {
  if (OverlayHoverClass === VOID) {
    class $ extends Semantic() {
      static mjo() {
        OverlayHover_instance = null;
        var $this = this.dd1('ovrlyhvr');
        OverlayHover_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = Companion_getInstance_0().saz_1;
        var tmp_0 = HoverSemantic_getInstance();
        return this.md1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp_0, OverlayHover$default$lambda))).bb1_1;
      }
      toString() {
        return 'OverlayHover';
      }
      hashCode() {
        return -1286188034;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OverlayHover()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'OverlayHover');
    OverlayHoverClass = $;
  }
  return OverlayHoverClass;
}
var OverlayHover_instance;
function OverlayHover_getInstance() {
  if (OverlayHover_instance === VOID)
    OverlayHover().mjo();
  return OverlayHover_instance;
}
var CountSemanticClass;
function CountSemantic() {
  if (CountSemanticClass === VOID) {
    class $ extends Semantic() {
      static ojo() {
        CountSemantic_instance = null;
        var $this = this.dd1('count');
        CountSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_cornerRadii = new (ForceConstant())(get_rem_0(0.5));
        var tmp1_font = copy(theme.gb0_1, VOID, div(times(theme.gb0_1.xb2_1, 2), 3), VOID, true, VOID, 1.0);
        var tmp2_padding = Edges().cd0(get_rem_0(0.2));
        return this.jd1(theme, VOID, tmp1_font, VOID, tmp0_cornerRadii, VOID, tmp2_padding);
      }
      toString() {
        return 'CountSemantic';
      }
      hashCode() {
        return -523584253;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CountSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CountSemantic');
    CountSemanticClass = $;
  }
  return CountSemanticClass;
}
var CountSemantic_instance;
function CountSemantic_getInstance() {
  if (CountSemantic_instance === VOID)
    CountSemantic().ojo();
  return CountSemantic_instance;
}
var UnreadClass;
function Unread() {
  if (UnreadClass === VOID) {
    class $ extends Semantic() {
      static qjo() {
        Unread_instance = null;
        var $this = this.dd1('unrd');
        Unread_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_iconOverride = AppColors_getInstance().ffz_1.zg9_1;
        var tmp1_background = AppColors_getInstance().ffz_1.zg9_1;
        var tmp2_foreground = Companion_getInstance_0().taz_1;
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, tmp0_iconOverride, VOID, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'Unread';
      }
      hashCode() {
        return -1405989279;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Unread()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Unread');
    UnreadClass = $;
  }
  return UnreadClass;
}
var Unread_instance;
function Unread_getInstance() {
  if (Unread_instance === VOID)
    Unread().qjo();
  return Unread_instance;
}
var ActionNeededClass;
function ActionNeeded() {
  if (ActionNeededClass === VOID) {
    class $ extends Semantic() {
      static sjo() {
        ActionNeeded_instance = null;
        var $this = this.dd1('actneed');
        ActionNeeded_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, color(ProjectState_InProgress_getInstance()));
      }
      toString() {
        return 'ActionNeeded';
      }
      hashCode() {
        return -200032579;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ActionNeeded()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ActionNeeded');
    ActionNeededClass = $;
  }
  return ActionNeededClass;
}
var ActionNeeded_instance;
function ActionNeeded_getInstance() {
  if (ActionNeeded_instance === VOID)
    ActionNeeded().sjo();
  return ActionNeeded_instance;
}
var InitialIconSemanticClass;
function InitialIconSemantic() {
  if (InitialIconSemanticClass === VOID) {
    class $ extends Semantic() {
      static ujo() {
        InitialIconSemantic_instance = null;
        var $this = this.dd1('ntIcn');
        InitialIconSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var backIsWhite = theme.qb0_1.db2().equals(Companion_getInstance_0().taz_1);
        var tmp2_$receiver = theme.fb1(ButtonSemantic_getInstance()).gb1_1;
        var tmp3_cornerRadii = new (RatioOfSize())(1.0);
        var tmp4_background = backIsWhite ? AppColors_getInstance().efz_1.zg9_1 : theme.qb0_1;
        var tmp5_foreground = backIsWhite ? AppColors_getInstance().efz_1.cga_1 : Companion_getInstance_0().taz_1;
        var tmp6_outline = backIsWhite ? theme.nb0_1 : Companion_getInstance_0().taz_1;
        var tmp7_outlineWidth = backIsWhite ? get_dp(0) : get_dp(1);
        var tmp8_padding = Edges().cd0(get_dp(3));
        var tmp0_$this = theme.gb0_1;
        var tmp1_size = get_rem(1);
        var tmp9_font = tmp0_$this.fd1(VOID, VOID, 800, true, 1.0, VOID, tmp1_size);
        return this.jd1(tmp2_$receiver, VOID, tmp9_font, VOID, tmp3_cornerRadii, VOID, tmp8_padding, tmp5_foreground, VOID, tmp6_outline, tmp7_outlineWidth, VOID, tmp4_background);
      }
      toString() {
        return 'InitialIconSemantic';
      }
      hashCode() {
        return -1755315887;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InitialIconSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InitialIconSemantic');
    InitialIconSemanticClass = $;
  }
  return InitialIconSemanticClass;
}
var InitialIconSemantic_instance;
function InitialIconSemantic_getInstance() {
  if (InitialIconSemantic_instance === VOID)
    InitialIconSemantic().ujo();
  return InitialIconSemantic_instance;
}
var MessageSectionSubHeaderSemanticClass;
function MessageSectionSubHeaderSemantic() {
  if (MessageSectionSubHeaderSemanticClass === VOID) {
    class $ extends Semantic() {
      static wjo() {
        MessageSectionSubHeaderSemantic_instance = null;
        var $this = this.dd1('msgSbhdr');
        MessageSectionSubHeaderSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, theme.gb0_1.fd1(VOID, VOID, VOID, true), VOID, VOID, VOID, VOID, applyAlpha(theme.lb0_1, 0.3));
      }
      toString() {
        return 'MessageSectionSubHeaderSemantic';
      }
      hashCode() {
        return 890022435;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageSectionSubHeaderSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'MessageSectionSubHeaderSemantic');
    MessageSectionSubHeaderSemanticClass = $;
  }
  return MessageSectionSubHeaderSemanticClass;
}
var MessageSectionSubHeaderSemantic_instance;
function MessageSectionSubHeaderSemantic_getInstance() {
  if (MessageSectionSubHeaderSemantic_instance === VOID)
    MessageSectionSubHeaderSemantic().wjo();
  return MessageSectionSubHeaderSemantic_instance;
}
var PunchFieldSemanticClass;
function PunchFieldSemantic() {
  if (PunchFieldSemanticClass === VOID) {
    class $ extends Semantic() {
      static yjo() {
        PunchFieldSemantic_instance = null;
        var $this = this.dd1('pnchfld');
        PunchFieldSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.jd1(theme.fb1(FieldSemantic_getInstance()).gb1_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().hfz_1.bga_1);
      }
      toString() {
        return 'PunchFieldSemantic';
      }
      hashCode() {
        return -964287996;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PunchFieldSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PunchFieldSemantic');
    PunchFieldSemanticClass = $;
  }
  return PunchFieldSemanticClass;
}
var PunchFieldSemantic_instance;
function PunchFieldSemantic_getInstance() {
  if (PunchFieldSemantic_instance === VOID)
    PunchFieldSemantic().yjo();
  return PunchFieldSemantic_instance;
}
var RemoveOutlineClass;
function RemoveOutline() {
  if (RemoveOutlineClass === VOID) {
    class $ extends Semantic() {
      static ajp() {
        RemoveOutline_instance = null;
        var $this = this.dd1('rmvout');
        RemoveOutline_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, get_px(0));
      }
      toString() {
        return 'RemoveOutline';
      }
      hashCode() {
        return -739122132;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemoveOutline()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'RemoveOutline');
    RemoveOutlineClass = $;
  }
  return RemoveOutlineClass;
}
var RemoveOutline_instance;
function RemoveOutline_getInstance() {
  if (RemoveOutline_instance === VOID)
    RemoveOutline().ajp();
  return RemoveOutline_instance;
}
function MobileNavSemantic$default$lambda($this$to, bar) {
  var tmp0_background = AppColors_getInstance().efz_1.yg9_1;
  var tmp1_foreground = Companion_getInstance_0().taz_1;
  var tmp = HoverSemantic_getInstance();
  var tmp2_derivations = mapOf(to(tmp, MobileNavSemantic$default$lambda$lambda));
  return $this$to.jd1(bar, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp2_derivations);
}
function MobileNavSemantic$default$lambda$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().mfz_1.zg9_1);
}
function MobileNavSemantic$default$lambda_0($this$to, nav) {
  var tmp = SelectedSemantic_getInstance();
  var tmp_0 = to(tmp, MobileNavSemantic$default$lambda$lambda_0);
  var tmp_1 = UnselectedSemantic_getInstance();
  return $this$to.gd1(nav, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf_0([tmp_0, to(tmp_1, MobileNavSemantic$default$lambda$lambda_1)]));
}
function MobileNavSemantic$default$lambda$lambda_0($this$to, it) {
  return $this$to.gd1(it, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().ffz_1.zg9_1);
}
function MobileNavSemantic$default$lambda$lambda_1($this$to, it) {
  var tmp0_background = Companion_getInstance_0().taz_1;
  var tmp1_foreground = AppColors_getInstance().efz_1.zg9_1;
  return $this$to.gd1(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background);
}
var MobileNavSemanticClass;
function MobileNavSemantic() {
  if (MobileNavSemanticClass === VOID) {
    class $ extends Semantic() {
      static cjp() {
        MobileNavSemantic_instance = null;
        var $this = this.dd1('mobnav');
        MobileNavSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = BarSemantic_getInstance();
        var tmp_0 = to(tmp, MobileNavSemantic$default$lambda);
        var tmp_1 = NavSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf_0([tmp_0, to(tmp_1, MobileNavSemantic$default$lambda_0)]));
      }
      toString() {
        return 'MobileNavSemantic';
      }
      hashCode() {
        return 1241925653;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MobileNavSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'MobileNavSemantic');
    MobileNavSemanticClass = $;
  }
  return MobileNavSemanticClass;
}
var MobileNavSemantic_instance;
function MobileNavSemantic_getInstance() {
  if (MobileNavSemantic_instance === VOID)
    MobileNavSemantic().cjp();
  return MobileNavSemantic_instance;
}
function get_withoutPadding(_this__u8e3s4) {
  _init_properties_appTheme_kt__k2rfoo();
  return new (withoutPadding$1())(_this__u8e3s4);
}
function matchAlpha(_this__u8e3s4, other) {
  _init_properties_appTheme_kt__k2rfoo();
  // Inline function 'kotlin.let' call
  var alpha = other.db2().jaz_1;
  return _this__u8e3s4.wcy((it) => it.fcz(alpha));
}
var TestServerSemanticClass;
function TestServerSemantic() {
  if (TestServerSemanticClass === VOID) {
    class $ extends Semantic() {
      static ejp() {
        TestServerSemantic_instance = null;
        var $this = this.dd1('tstsvr');
        TestServerSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_outlineWidth = get_dp(3);
        var tmp1_background = Companion_getInstance_0().ccz('6d0101');
        var tmp2_outline = Companion_getInstance_0().waz_1;
        var tmp3_foreground = Companion_getInstance_0().taz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_foreground, VOID, tmp2_outline, tmp0_outlineWidth, VOID, tmp1_background);
      }
      toString() {
        return 'TestServerSemantic';
      }
      hashCode() {
        return 510793485;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TestServerSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TestServerSemantic');
    TestServerSemanticClass = $;
  }
  return TestServerSemanticClass;
}
var TestServerSemantic_instance;
function TestServerSemantic_getInstance() {
  if (TestServerSemantic_instance === VOID)
    TestServerSemantic().ejp();
  return TestServerSemantic_instance;
}
var NothingHereSemanticClass;
function NothingHereSemantic() {
  if (NothingHereSemanticClass === VOID) {
    class $ extends Semantic() {
      static gjp() {
        NothingHereSemantic_instance = null;
        var $this = this.dd1('nthnghere');
        NothingHereSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme.fb1(CompactSemantic_getInstance()).gb1_1, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().hfz_1.yg9_1);
      }
      toString() {
        return 'NothingHereSemantic';
      }
      hashCode() {
        return -587450159;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NothingHereSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NothingHereSemantic');
    NothingHereSemanticClass = $;
  }
  return NothingHereSemanticClass;
}
var NothingHereSemantic_instance;
function NothingHereSemantic_getInstance() {
  if (NothingHereSemantic_instance === VOID)
    NothingHereSemantic().gjp();
  return NothingHereSemantic_instance;
}
var GroupedInformationSemanticClass;
function GroupedInformationSemantic() {
  if (GroupedInformationSemanticClass === VOID) {
    class $ extends Semantic() {
      static ijp() {
        GroupedInformationSemantic_instance = null;
        var $this = this.dd1('grpdinfo');
        GroupedInformationSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, false, VOID, VOID, VOID, times_0(theme.jb0_1, 1.5));
      }
      toString() {
        return 'GroupedInformationSemantic';
      }
      hashCode() {
        return 678996102;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupedInformationSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'GroupedInformationSemantic');
    GroupedInformationSemanticClass = $;
  }
  return GroupedInformationSemanticClass;
}
var GroupedInformationSemantic_instance;
function GroupedInformationSemantic_getInstance() {
  if (GroupedInformationSemantic_instance === VOID)
    GroupedInformationSemantic().ijp();
  return GroupedInformationSemantic_instance;
}
var NotImportantSemanticClass;
function NotImportantSemantic() {
  if (NotImportantSemanticClass === VOID) {
    class $ extends Semantic() {
      static kjp() {
        NotImportantSemantic_instance = null;
        var $this = this.dd1('ntiprt');
        NotImportantSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().hfz_1.zg9_1);
      }
      toString() {
        return 'NotImportantSemantic';
      }
      hashCode() {
        return -893507417;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotImportantSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NotImportantSemantic');
    NotImportantSemanticClass = $;
  }
  return NotImportantSemanticClass;
}
var NotImportantSemantic_instance;
function NotImportantSemantic_getInstance() {
  if (NotImportantSemantic_instance === VOID)
    NotImportantSemantic().kjp();
  return NotImportantSemantic_instance;
}
function NoHoverSemantic$default$lambda($this$to, it) {
  return it.cb1_1;
}
function NoHoverSemantic$default$lambda_0($this$to, it) {
  return it.cb1_1;
}
var NoHoverSemanticClass;
function NoHoverSemantic() {
  if (NoHoverSemanticClass === VOID) {
    class $ extends Semantic() {
      static mjp() {
        NoHoverSemantic_instance = null;
        var $this = this.dd1('nohvr');
        NoHoverSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = HoverSemantic_getInstance();
        var tmp_0 = to(tmp, NoHoverSemantic$default$lambda);
        var tmp_1 = DownSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf_0([tmp_0, to(tmp_1, NoHoverSemantic$default$lambda_0)]));
      }
      toString() {
        return 'NoHoverSemantic';
      }
      hashCode() {
        return -225447825;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NoHoverSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NoHoverSemantic');
    NoHoverSemanticClass = $;
  }
  return NoHoverSemanticClass;
}
var NoHoverSemantic_instance;
function NoHoverSemantic_getInstance() {
  if (NoHoverSemantic_instance === VOID)
    NoHoverSemantic().mjp();
  return NoHoverSemantic_instance;
}
function get_appTheme() {
  _init_properties_appTheme_kt__k2rfoo();
  return get_appThemeLive().f2();
}
function invalidOutlineTheme$lambda(_this__u8e3s4) {
  _init_properties_appTheme_kt__k2rfoo();
  var tmp0_cornerRadii = new (Constant())(get_AppDimensions().rg2_1);
  var tmp1_outlineWidth = get_AppDimensions().qg2_1;
  var tmp2_outline = AppColors_getInstance().jfz_1.zg9_1;
  return _this__u8e3s4.yd1(VOID, VOID, VOID, VOID, tmp0_cornerRadii, VOID, VOID, VOID, VOID, tmp2_outline, tmp1_outlineWidth);
}
function appThemeLive$lambda(dimensions) {
  _init_properties_appTheme_kt__k2rfoo();
  var tmp0_font = new (FontAndStyle())(Resources_getInstance().vf8_1);
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_1();
  var tmp1_transitionDuration = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  var tmp2_foreground = Companion_getInstance_0().vaz_1;
  var tmp3_background = Companion_getInstance_0().taz_1;
  var tmp4_elevation = get_dp(0);
  var tmp5_cornerRadii = new (Constant())(get_px(0));
  var tmp6_outlineWidth = get_dp(0);
  var tmp7_outline = AppColors_getInstance().hfz_1.aga_1;
  var tmp = ErrorSemantic_getInstance();
  var tmp_0 = to(tmp, appThemeLive$lambda$lambda);
  var tmp_1 = ButtonSemantic_getInstance();
  var tmp_2 = to(tmp_1, ($this$to, it) => $this$to.jd1(it, VOID, VOID, VOID, new (Constant())(dimensions.rg2_1), dimensions.lg2_1, Edges().cd0(dimensions.lg2_1)));
  var tmp_3 = HoverSemantic_getInstance();
  var tmp_4 = to(tmp_3, appThemeLive$lambda$lambda_0);
  var tmp_5 = DownSemantic_getInstance();
  var tmp_6 = to(tmp_5, appThemeLive$lambda$lambda_1);
  var tmp_7 = CardSemantic_getInstance();
  var tmp_8 = to(tmp_7, appThemeLive$lambda$lambda_2);
  var tmp_9 = FieldSemantic_getInstance();
  var tmp_10 = to(tmp_9, appThemeLive$lambda$lambda_3);
  var tmp_11 = FocusSemantic_getInstance();
  var tmp_12 = to(tmp_11, appThemeLive$lambda$lambda_4);
  var tmp_13 = DialogSemantic_getInstance();
  var tmp_14 = to(tmp_13, ($this$to, it) => {
    var tmp0_outlineWidth = dimensions.qg2_1;
    var tmp1_cornerRadii = new (Constant())(dimensions.rg2_1);
    var tmp2_padding = Edges().cd0(get_AppDimensions().yg1_1);
    var tmp = CardSemantic_getInstance();
    var tmp3_derivations = mapOf(to(tmp, appThemeLive$lambda$lambda$lambda));
    return $this$to.jd1(it, false, VOID, VOID, tmp1_cornerRadii, VOID, tmp2_padding, VOID, VOID, VOID, tmp0_outlineWidth, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_derivations);
  });
  var tmp_15 = PopoverSemantic_getInstance();
  var tmp_16 = to(tmp_15, ($this$to, it) => {
    var tmp0_outlineWidth = dimensions.qg2_1;
    var tmp1_cornerRadii = new (Constant())(dimensions.rg2_1);
    var tmp2_padding = Edges().cd0(get_rem(1));
    var tmp = CardSemantic_getInstance();
    var tmp3_derivations = mapOf(to(tmp, appThemeLive$lambda$lambda$lambda_0));
    return $this$to.jd1(it, false, VOID, VOID, tmp1_cornerRadii, VOID, tmp2_padding, VOID, VOID, VOID, tmp0_outlineWidth, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_derivations);
  });
  var tmp_17 = NavSemantic_getInstance();
  var tmp_18 = to(tmp_17, appThemeLive$lambda$lambda_5);
  var tmp_19 = BarSemantic_getInstance();
  var tmp_20 = to(tmp_19, appThemeLive$lambda$lambda_6);
  var tmp_21 = InvalidSemantic_getInstance();
  var tmp_22 = to(tmp_21, ($this$to, it) => $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().jfz_1.zg9_1, dimensions.qg2_1));
  var tmp_23 = SelectedSemantic_getInstance();
  var tmp_24 = to(tmp_23, appThemeLive$lambda$lambda_7);
  var tmp_25 = UnselectedSemantic_getInstance();
  var tmp_26 = to(tmp_25, ($this$to, it) => {
    var tmp0_background = Companion_getInstance_0().taz_1;
    var tmp1_outlineWidth = dimensions.qg2_1;
    var tmp2_outline = matchAlpha(AppColors_getInstance().hfz_1.zg9_1, it.lb0_1);
    return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_outline, tmp1_outlineWidth, VOID, tmp0_background);
  });
  var tmp_27 = WarningSemantic_getInstance();
  var tmp_28 = to(tmp_27, appThemeLive$lambda$lambda_8);
  var tmp_29 = DangerSemantic_getInstance();
  var tmp_30 = to(tmp_29, appThemeLive$lambda$lambda_9);
  var tmp_31 = ListSemantic_getInstance();
  var tmp8_derivations = mapOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, to(tmp_31, appThemeLive$lambda$lambda_10)]);
  return new (Theme())('main', tmp0_font, tmp4_elevation, tmp5_cornerRadii, VOID, VOID, tmp2_foreground, VOID, tmp7_outline, tmp6_outlineWidth, VOID, tmp3_background, VOID, VOID, VOID, VOID, tmp1_transitionDuration, VOID, VOID, VOID, tmp8_derivations);
}
function appThemeLive$lambda$lambda($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.gd1(it, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().jfz_1.zg9_1);
}
function appThemeLive$lambda$lambda_0($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, darken(it.qb0_1, 0.2));
}
function appThemeLive$lambda$lambda_1($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, darken(it.qb0_1, 0.4));
}
function appThemeLive$lambda$lambda_2($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  var currentIsDark = it.qb0_1.db2().rcz().ad0_1 < 0.95;
  return $this$to.jd1(it.fb1(Outlined_getInstance()).gb1_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentIsDark ? Companion_getInstance_0().taz_1 : AppColors_getInstance().hfz_1.bga_1);
}
function appThemeLive$lambda$lambda_3($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return it.fb1(Outlined_getInstance());
}
function appThemeLive$lambda$lambda_4($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.nb0_1.db2().equals(AppColors_getInstance().jfz_1.bga_1) ? AppColors_getInstance().jfz_1.aga_1 : AppColors_getInstance().hfz_1.zg9_1);
}
function appThemeLive$lambda$lambda$lambda($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return it.cb1_1;
}
function appThemeLive$lambda$lambda$lambda_0($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return it.cb1_1;
}
function appThemeLive$lambda$lambda_5($this$to, nav) {
  _init_properties_appTheme_kt__k2rfoo();
  var tmp0_background = AppColors_getInstance().efz_1.yg9_1;
  var tmp1_foreground = Companion_getInstance_0().taz_1;
  var tmp = HoverSemantic_getInstance();
  var tmp_0 = to(tmp, appThemeLive$lambda$lambda$lambda_1);
  var tmp_1 = DownSemantic_getInstance();
  var tmp_2 = to(tmp_1, appThemeLive$lambda$lambda$lambda_2);
  var tmp_3 = SelectedSemantic_getInstance();
  var tmp_4 = to(tmp_3, appThemeLive$lambda$lambda$lambda_3);
  var tmp_5 = UnselectedSemantic_getInstance();
  var tmp2_derivations = mapOf_0([tmp_0, tmp_2, tmp_4, to(tmp_5, appThemeLive$lambda$lambda$lambda_4)]);
  return $this$to.md1(nav, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp2_derivations).bb1_1;
}
function appThemeLive$lambda$lambda$lambda_1($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().mfz_1.zg9_1);
}
function appThemeLive$lambda$lambda$lambda_2($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().mfz_1.yg9_1);
}
function appThemeLive$lambda$lambda$lambda_3($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().mfz_1.zg9_1);
}
function appThemeLive$lambda$lambda$lambda_4($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().efz_1.yg9_1);
}
function appThemeLive$lambda$lambda_6($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.gd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().efz_1.zg9_1);
}
function appThemeLive$lambda$lambda_7($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  var tmp0_background = AppColors_getInstance().hfz_1.bga_1;
  var tmp1_outlineWidth = get_px(0);
  var tmp2_outline = Companion_getInstance_0().saz_1;
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_outline, tmp1_outlineWidth, VOID, tmp0_background);
}
function appThemeLive$lambda$lambda_8($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().kfz_1.zg9_1);
}
function appThemeLive$lambda$lambda_9($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().jfz_1.aga_1);
}
function appThemeLive$lambda$lambda_10($this$to, it) {
  _init_properties_appTheme_kt__k2rfoo();
  var tmp0_gap = get_dp(3);
  return $this$to.gd1(it, false, VOID, VOID, VOID, tmp0_gap);
}
var withoutPadding$1Class;
function withoutPadding$1() {
  if (withoutPadding$1Class === VOID) {
    class $ {
      constructor($this_withoutPadding) {
        this.njp_1 = $this_withoutPadding;
      }
      hd1(theme) {
        return this.njp_1.hd1(theme).pd1(VOID, VOID, false);
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    withoutPadding$1Class = $;
  }
  return withoutPadding$1Class;
}
var properties_initialized_appTheme_kt_8shfp2;
function _init_properties_appTheme_kt__k2rfoo() {
  if (!properties_initialized_appTheme_kt_8shfp2) {
    properties_initialized_appTheme_kt_8shfp2 = true;
    invalidOutlineTheme = invalidOutlineTheme$lambda;
    var tmp = Companion_getInstance().ugf_1;
    appThemeLive = lens(tmp, appThemeLive$lambda);
  }
}
//region block: exports
export {
  get_appTheme as get_appThemejy2o9bdilpry,
  get_appThemeLive as get_appThemeLive3eistjx4ilovl,
  matchAlpha as matchAlphaf1v7f410jfqp,
  get_outlined as get_outlinedfhcs63de0vzu,
  get_redText as get_redText11s08hp3hs1x3,
  get_withoutPadding as get_withoutPadding21hnjxk91b1qc,
  ActionNeeded_getInstance as ActionNeeded_getInstance23nk3i9c67lq9,
  AuthDialogSemantic_getInstance as AuthDialogSemantic_getInstancetw8ua0jubs3m,
  CountSemantic_getInstance as CountSemantic_getInstance1ocl325ub48re,
  GroupedInformationSemantic_getInstance as GroupedInformationSemantic_getInstance10la8ntbgzaf6,
  InitialIconSemantic_getInstance as InitialIconSemantic_getInstanceaqd9z1nvlka3,
  MessageSectionSubHeaderSemantic_getInstance as MessageSectionSubHeaderSemantic_getInstance2a24vkxcf46oz,
  MobileNavSemantic_getInstance as MobileNavSemantic_getInstance35ah13hrpn1em,
  NoHoverSemantic_getInstance as NoHoverSemantic_getInstance1icuasw0irscx,
  NotImportantSemantic_getInstance as NotImportantSemantic_getInstanceqhz8j2q97ips,
  NothingHereSemantic_getInstance as NothingHereSemantic_getInstance3tro8v94k1jgs,
  Outlined_getInstance as Outlined_getInstancey8v9xg2p90sg,
  OverlayHover_getInstance as OverlayHover_getInstances85cpyxi08dm,
  PunchFieldSemantic_getInstance as PunchFieldSemantic_getInstance17evc960lld2j,
  RemoveOutline_getInstance as RemoveOutline_getInstance2r2ekg5cxorga,
  TestServerSemantic_getInstance as TestServerSemantic_getInstance3job4xjohh5n6,
  Unread_getInstance as Unread_getInstance2ucj3ofncdx90,
};
//endregion

//# sourceMappingURL=appTheme.mjs.map
